const Styles = {
  fullScreenCalendarContainerStyle: {
    width: '50%',
    zIndex: 200,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    minHeight: '100vh'
  },
  halfScreenCalendarContainerStyle: {
    width: '100%',
    zIndex: 200,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    minHeight: '100vh'
  },
  bookingsContainer: {
    flexDirection: 'column',
    width: '50%',
    zIndex: 200,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minHeight: '100vh'
  },
  schemeContainerStyle: {
    display: 'flex',
    flexDirection: 'column'
  },
  backgroundFadeStyle: {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    width: '100%',
    minHeight: '100%',
    position: 'absolute',
    zIndex: 900,
    top: 0,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
  currentContainerStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  }
}

export default Styles



// WEBPACK FOOTER //
// ./src/components/pages/laundries/LaundryBooking/styles.js